<template>
  <div class="EduTaxRebateWidgetGovMB__container" v-if="loaded">
    <button type="button" @click="$router.push('/')">Home</button>
    <button type="button" @click="$router.push('texts')">Texts</button>
    <button type="button" @click="$router.push('data')">Data</button>
    <h1 style="font-weight:bold; font-size:2rem; line-height:1.5em;">Common</h1>
    <table border="1" style="margin-bottom:100px;" >
      <tr><th style="padding:5px; vertical-align:top; ">Section</th><th style="padding:5px; vertical-align:top; width:33%">English</th><th style="padding:5px; vertical-align:top; width:33%">French</th></tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">headerTitle</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('headerTitle','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('headerTitle','fr-CA')"></td>
      </tr>
      <tr v-if="false">
        <td style="padding:5px; vertical-align:top;">headerTotalText</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('headerTotalText','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('headerTotalText','fr-CA')"></td>
      </tr>
      <tr v-if="false">
        <td style="padding:5px; vertical-align:top;">headerTotalAsOfText</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('headerTotalAsOfText','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('headerTotalAsOfText','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">headerIntro</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('headerIntro','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('headerIntro','fr-CA')"></td>
      </tr>
      <tr v-if="false">
        <td style="padding:5px; vertical-align:top;">headerBody</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('headerBody','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('headerBody','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">headerSubtitle</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('headerSubtitle','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('headerSubtitle','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">boxHeaderTitle</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('boxHeaderTitle','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('boxHeaderTitle','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">boxHeaderInfo</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('boxHeaderInfo','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('boxHeaderInfo','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">boxSubHeaderTitle</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('boxSubHeaderTitle','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('boxSubHeaderTitle','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">boxSubHeaderSubTitle</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('boxSubHeaderSubTitle','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('boxSubHeaderSubTitle','fr-CA')"></td>
      </tr>
      <tr v-if="false">
        <td style="padding:5px; vertical-align:top;">lastUpdated</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('lastUpdated','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('lastUpdated','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">class</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('class','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('class','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">propertyHeader</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('propertyHeader','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('propertyHeader','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">assessmentHeader</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('assessmentHeader','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('assessmentHeader','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">selectClass</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('selectClass','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('selectClass','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">portionedAssessment</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('portionedAssessment','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('portionedAssessment','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">schoolDivisionMillRate</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('schoolDivisionMillRate','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('schoolDivisionMillRate','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">educationSupportLevy</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('educationSupportLevy','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('educationSupportLevy','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">schoolTax</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('schoolTax','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('schoolTax','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">educationPropertyTaxRebate</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('educationPropertyTaxRebate','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('educationPropertyTaxRebate','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">class.residential1</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('class.residential1','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('class.residential1','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">class.residential2</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('class.residential2','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('class.residential2','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">class.residential3</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('class.residential3','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('class.residential3','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">class.farmProperty</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('class.farmProperty','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('class.farmProperty','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">class.otherProperty</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('class.otherProperty','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('class.otherProperty','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">Total Rebate</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('Total Rebate','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('Total Rebate','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">disclaimer</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('disclaimer','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('disclaimer','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">calculate</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('calculate','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('calculate','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">rollNumber</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('rollNumber','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('rollNumber','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">addPropertyButton</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('addPropertyButton','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('addPropertyButton','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">addAssessmentButton</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('addAssessmentButton','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('addAssessmentButton','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">removePropertyButton</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('removePropertyButton','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('removePropertyButton','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">removeAssessmentButton</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('removeAssessmentButton','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('removeAssessmentButton','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">nullRollNumber</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('nullRollNumber','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('nullRollNumber','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">summaryTitle</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('summaryTitle','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('summaryTitle','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">summaryTotalsHeading</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('summaryTotalsHeading','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('summaryTotalsHeading','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">summaryTaxHeading</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('summaryTaxHeading','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('summaryTaxHeading','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">summaryRebateHeading</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('summaryRebateHeading','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('summaryRebateHeading','fr-CA')"></td>
      </tr>
      <tr v-if="false">
        <td style="padding:5px; vertical-align:top;">summaryRebateBody</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('summaryRebateBody','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('summaryRebateBody','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">rebate</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('rebate','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('rebate','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">propertyRebate</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('propertyRebate','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('propertyRebate','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">help</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">help.schoolDivisionMillRate.residential1</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.schoolDivisionMillRate.residential1','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.schoolDivisionMillRate.residential1','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">help.schoolDivisionMillRate.residential2</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.schoolDivisionMillRate.residential2','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.schoolDivisionMillRate.residential2','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">help.schoolDivisionMillRate.residential3</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.schoolDivisionMillRate.residential3','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.schoolDivisionMillRate.residential3','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">help.schoolDivisionMillRate.farmProperty</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.schoolDivisionMillRate.farmProperty','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.schoolDivisionMillRate.farmProperty','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">help.schoolDivisionMillRate.otherProperty</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.schoolDivisionMillRate.otherProperty','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.schoolDivisionMillRate.otherProperty','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">help.educationSupportLevy.otherProperty</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.educationSupportLevy.otherProperty','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.educationSupportLevy.otherProperty','fr-CA')"></td>
      </tr>
      <tr>
        <td style="padding:5px; vertical-align:top;">help.ok</td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.ok','en-CA')"></td>
        <td style="padding:5px; vertical-align:top;" v-html="$t('help.ok','fr-CA')"></td>
      </tr>

     </table>



</div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import Format from '../utility/Format'
import numeral from 'numeral'
import {GGanttChart, GGanttRow} from '../components/vue-ganttastic/src'
import HorizontalScroll from 'vue-horizontal-scroll'


export default {
  data () {
    return {
      model: {
        group:null,
        age:null,
        question:null,
        totalBefore:0,
        totalAfter:0,
        totalAhead:0,
        totalDosesAllocated:0,
        queueStart:0,
        queueEnd:0,
        totalImmunized:0,
        totalPopulation:0,
        uptakePercentage:"70",
        data:null,
      },
      showRange:false, // whether to show the full range of population or not.
      Format,
      fullVersion:true,
      peopleIcons:[],
      questions:null,
      activeBarHover : null,
      groups:null,
      asOfDate:null,
      sliderData:{'70':'70%','80':'80%','90':'90%','100':'100%'},
      sliderMarks:{'70':{label:'70%'},'80':{label:'80%'},'90':{label:'90%'},'100':{label:'100%'}},
      ageOnlyAnswers:null,
      showDosesOnly: false,
      showCustomGroupMessage: false,
      showEstimate:false,
      showPregnant:false,
      showQueuePosition:false,
      value:0,
      showAgeRequired:false,
      showChildren:false,
      isFnPop:false,
      loaded:true,
      renderCount:0,

      chartStartDate: "2021-01-01 00:00",
      chartEndDate: "2021-12-31 00:00",
      rows:[],
      fnRows:[],
      popRows:[],
      allRows: [
      {
        label: "Sample",
        bars: [
        {
          startDate: "2021-01-01 12:10",
          endDate: "2021-03-01 16:35",
          total:1000,
          progress:100,
        }
        ]
      },
      {
        label: "Another",
        bars: [
        {
          ganttBarConfig: {
            label:"hey",
            color:"white",
            backgroundColor: "#404040",
            opacity: 0.5,
            immobile: true
          },
          startDate: "2021-04-02 01:00",
          endDate: "2021-07-02 12:00",
          total:500,
          progress:12,
        },
        {
          startDate: "2021-08-02 13:00",
          endDate: "2021-09-02 22:00",
          total:30000,
          progress:100,
        }
        ]
      }
      ]

    }
  },
  components: {
   GGanttChart,
   GGanttRow,
   HorizontalScroll
 },
 methods: {
  ...mapMutations([
  ]),

  scrollToResults() {
    const el = this.$el.getElementsByClassName('scroll-to-me')[0];

    if (el) {
      // Use el.scrollIntoView() to instantly scroll to the element
      el.scrollIntoView({behavior: 'smooth'});
    }
  },

  formatNumber(num) {
    return numeral(num).format();
  },

  getParsedString(val) {
    let text = ""+val;
    return text.formatUnicorn(this.model.group[this.$store.state.lang].barLabel, numeral(this.model.group.uptakePopulation).format(),numeral(this.model.group.totalImmunized).format(), numeral(this.model.queueStart).format(), numeral(this.model.queueEnd).format(),     numeral(this.model.group.dosesAllocated).format("0,0"),numeral(this.model.group.ahead).format("0,0"),this.model.uptakePercentage,numeral(this.model.group.aheadUpper).format("0,0"));
  },

  setPeopleIcons() {
    this.peopleIcons = [];
    if (!this.loaded) {
      return;
    }
    if (this.model.group == null) {
     return;
   }
      // var weeks = Math.abs(this.$moment(this.chartStartDate).diff(this.$moment(this.chartEndDate), 'weeks')) ;
      var mySlot = 999;
      var totalPeople = [];
      let x = 0;
      let xx = 0;

      for ( x = 0; x < this.groups.length; x++) {
        if ( (this.isFnPop && this.groups[x].id.substr(0,3) != "age")  || (!this.isFnPop && this.groups[x].id.substr(0,5) != "fnAge")) {
          if (this.groups[x].showVaccinate == 1) {
            if (this.model.group.id == this.groups[x].id ) {
              if (
              (
              this.groups[x].id == "personalCareResidents"
              || this.groups[x].id == "firstNationsPriority"
              ||this.groups[x].id == "healthcareWorkers"
                ||this.groups[x].id == "congregateLiving"
              )
              ) {
                mySlot = 0;
            } else {
              mySlot = totalPeople.length;
            }
          }
          if (
          (
          this.groups[x].id == "personalCareResidents"
          || this.groups[x].id == "firstNationsPriority"
          ||this.groups[x].id == "healthcareWorkers"
                ||this.groups[x].id == "congregateLiving"

          )
          ) {
            if (totalPeople.length == 0) {
              totalPeople.push(x);
            }
          } else {
            totalPeople.push(x);
          }
        }
      }
    }
    for ( xx = 0; xx < totalPeople.length; xx++) {
      if (xx == mySlot) {
        this.peopleIcons.push({
          icon: this.$store.state.baseUrl + require("../assets/img/person-queue.svg"),
          group:totalPeople[xx],
        });
      } else {
        if (xx > mySlot) {
         this.peopleIcons.push( {
           icon: this.$store.state.baseUrl + require("../assets/img/person-after.svg"),
           group:totalPeople[xx],
         });
       } else {
        this.peopleIcons.push( {
          icon: this.$store.state.baseUrl + require("../assets/img/person-ahead.svg"),
          group:totalPeople[xx],
        });
      }
    }
  }
},

setPeopleIconsSeparated() {
  this.peopleIcons = [];
  if (!this.loaded) {
    return;
  }
  if (this.model.group == null) {
   return;
 }
      // var weeks = Math.abs(this.$moment(this.chartStartDate).diff(this.$moment(this.chartEndDate), 'weeks')) ;
      var mySlot = 999;
      var totalPeople = [];
      let x = 0;
      let xx = 0;

      for ( x = 0; x < this.groups.length; x++) {
        if ( (this.isFnPop && this.groups[x].id.substr(0,3) != "age")  || (!this.isFnPop && this.groups[x].id.substr(0,5) != "fnAge")) {
          if (this.groups[x].showVaccinate == 1) {
            if (this.model.group.id == this.groups[x].id ) {
              mySlot = totalPeople.length;
            }
            totalPeople.push(x);
          }
        }
      }
      for ( xx = 0; xx < totalPeople.length; xx++) {
        if (xx == mySlot) {
          this.peopleIcons.push({
            icon: this.$store.state.baseUrl + require("../assets/img/person-queue.svg"),
            group:totalPeople[xx],
          });
        } else {
          if (xx > mySlot) {
           this.peopleIcons.push( {
             icon: this.$store.state.baseUrl + require("../assets/img/person-after.svg"),
             group:totalPeople[xx],
           });
         } else {
          this.peopleIcons.push( {
            icon: this.$store.state.baseUrl + require("../assets/img/person-ahead.svg"),
            group:totalPeople[xx],
          });
        }
      }
    }
  },

    setPeopleIconsRangedGrouped() {
        this.peopleIcons = [];
        if (!this.loaded) {
          return;
        }
        if (this.model.group == null) {
         return;
        }
       var weeks = Math.abs(this.$moment(this.chartStartDate).diff(this.$moment(this.chartEndDate), 'weeks')) ;
       var mySlot = 999;
       var groupLength = 0;
       var totalPeople = [];
       let x = 0;
       let xx = 0;
       let z = 0;
       let mySlotCount = 0;
       for ( x = 0; x < this.groups.length; x++) {
        if ( (this.isFnPop && this.groups[x].id.substr(0,3) != "age")  || (!this.isFnPop && this.groups[x].id.substr(0,5) != "fnAge")) {
          if (this.groups[x].showVaccinate == 1) {
            var thisPopPercent = 0;
            if (this.model.totalDosesAllocated != 0 && this.groups[x].ahead != 0) {
              thisPopPercent = this.groups[x].dosesAllocated / this.model.totalDosesAllocated;
            }
            groupLength = Math.ceil(thisPopPercent * weeks);
              if (this.model.group.id == this.groups[x].id ) {
                if (
                (
                this.groups[x].id == "personalCareResidents"
                || this.groups[x].id == "firstNationsPriority"
                ||this.groups[x].id == "healthcareWorkers"
                ||this.groups[x].id == "congregateLiving"
                )
                ) {
                  mySlot = 0;
                  mySlotCount = 1;
              } else {
                mySlot = totalPeople.length;
              }
            }
            if (
            (
            this.groups[x].id == "personalCareResidents"
            || this.groups[x].id == "firstNationsPriority"
            ||this.groups[x].id == "healthcareWorkers"
                ||this.groups[x].id == "congregateLiving"

            )
            ) {
              if (totalPeople.length == 0) {
                totalPeople.push(x);
              }
            } else {
              // totalPeople.push(x);
              for ( z = 0; z < groupLength; z++) {
                totalPeople.push(x);
                if (this.model.group.id == this.groups[x].id ) {
                  mySlotCount++;
                }
              }
            }

          }
        }
      }
      var lastGroup = null;
      var isFirst = false;
      for ( xx = 0; xx < totalPeople.length; xx++) {
        if ( (xx == mySlot) || (xx > mySlot && xx < (mySlotCount + mySlot))) {
          if (totalPeople[xx] != lastGroup) {
             isFirst = true;
          } else {
            isFirst = false;
          }
          lastGroup = totalPeople[xx];

          this.peopleIcons.push({
            icon: this.$store.state.baseUrl + require("../assets/img/person-queue.svg"),
            group:totalPeople[xx],
            mobile:isFirst,
          });
        } else {
          if (totalPeople[xx] != lastGroup) {
             isFirst = true;
          } else {
            isFirst = false;
          }
           lastGroup = totalPeople[xx];

          if (xx > mySlot) {
           this.peopleIcons.push( {
             icon: this.$store.state.baseUrl + require("../assets/img/person-after.svg"),
             group:totalPeople[xx],
             mobile:isFirst,
           });
          } else {
            this.peopleIcons.push( {
              icon: this.$store.state.baseUrl + require("../assets/img/person-ahead.svg"),
              group:totalPeople[xx],
              mobile:isFirst,
            });
          }
        }
      }



  },

  setPeopleIconsRanged() {
      this.peopleIcons = [];
      if (!this.loaded) {
        return;
      }
      if (this.model.group == null) {
       return;
      }
     var weeks = Math.abs(this.$moment(this.chartStartDate).diff(this.$moment(this.chartEndDate), 'weeks')) ;
     var mySlot = 999;
     var groupLength = 0;
     var groupImmunized = 0;
     var totalPeople = [];
     var totalPeopleImmunized = [];
     let x = 0;
     let xx = 0;
     let z = 0;

     for ( x = 0; x < this.groups.length; x++) {
      if ( (this.isFnPop && this.groups[x].id.substr(0,3) != "age")  || (!this.isFnPop && this.groups[x].id.substr(0,5) != "fnAge")) {
        if (this.groups[x].showVaccinate == 1) {
          var thisPopPercent = this.groups[x].uptakePopulation / this.model.uptakePopulation;
          var thisImmunePercent = 0;
          if (this.groups[x].totalImmunized != 0) {
            thisImmunePercent = this.groups[x].totalImmunized / this.groups[x].uptakePopulation;
          }
          groupLength = Math.ceil(thisPopPercent * weeks);
          groupImmunized = Math.ceil(thisImmunePercent * groupLength);
          if (this.model.group.id == this.groups[x].id ) {
            mySlot = totalPeople.length;
          }
          for ( z = 0; z < groupLength; z++) {
            totalPeople.push(x);
          }
          for ( z = 0; z < groupImmunized; z++) {
            totalPeopleImmunized.push(x);
          }

        }
      }
    }
    for ( xx = 0; xx < totalPeopleImmunized.length; xx++) {
      if (xx == mySlot) {
        this.peopleIcons.push({
          icon: this.$store.state.baseUrl + require("../assets/img/person-queue.svg"),
          group:totalPeople[xx],
        });
        mySlot = 999;
      } else {
        this.peopleIcons.push( {
          icon: this.$store.state.baseUrl + require("../assets/img/person-vaccinated.svg"),
          group:totalPeople[xx],
        });
      }
    }
    for ( xx = totalPeopleImmunized.length - 1; xx < totalPeople.length; xx++) {
      if (xx == mySlot) {
        this.peopleIcons.push({
          icon: this.$store.state.baseUrl + require("../assets/img/person-queue.svg"),
          group:totalPeople[xx],
        });
      } else {
        this.peopleIcons.push( {
          icon: this.$store.state.baseUrl + require("../assets/img/person-unvaccinated.svg"),
          group:totalPeople[xx],
        });
      }
    }
},

setUptakePercentage() {
  if (this.loaded && this.model) {
     this.$nextTick(() => {
        if (this.model.group) {
          if (this.model.uptakePercentage == "70") {
            this.model.group.ahead = this.model.group.ahead70;
            this.model.group.population = this.model.group.population70;
            this.model.group.aheadUpper = this.model.group.ahead + this.model.group.population;
          }
          if (this.model.uptakePercentage == "80") {
            this.model.group.ahead = this.model.group.ahead80;
            this.model.group.population = this.model.group.population80;
            this.model.group.aheadUpper = this.model.group.ahead + this.model.group.population;

          }
          if (this.model.uptakePercentage == "90") {
            this.model.group.ahead = this.model.group.ahead90;
            this.model.group.population = this.model.group.population90;
            this.model.group.aheadUpper = this.model.group.ahead + this.model.group.population;

          }
          if (this.model.uptakePercentage == "100") {
            this.model.group.ahead = this.model.group.ahead100;
            this.model.group.population = this.model.group.population100;
            this.model.group.aheadUpper = this.model.group.ahead + this.model.group.population;

          }
       }

       // loop through each group and row and set the ahead
       this.model.totalAhead = 0;
       this.model.totalDosesAllocated = 0;

       for (let g in this.groups) {
        if (this.groups[g].showVaccinate) {
          this.groups[g].uptakePercentage = this.model.uptakePercentage;
          if (this.model.uptakePercentage == "70") {
            this.groups[g].ahead= this.groups[g].ahead70;
            this.groups[g].population= this.groups[g].population70;
            this.groups[g].aheadUpper = this.groups[g].ahead + this.groups[g].population;

          }
          if (this.model.uptakePercentage == "80") {
            this.groups[g].ahead = this.groups[g].ahead80;
            this.groups[g].population= this.groups[g].population80;
            this.groups[g].aheadUpper = this.groups[g].ahead + this.groups[g].population;
          }
          if (this.model.uptakePercentage == "90") {
            this.groups[g].ahead = this.groups[g].ahead90;
            this.groups[g].population= this.groups[g].population90;
            this.groups[g].aheadUpper = this.groups[g].ahead + this.groups[g].population;

          }
          if (this.model.uptakePercentage == "100") {
            this.groups[g].ahead = this.groups[g].ahead100;
            this.groups[g].population= this.groups[g].population100;
            this.groups[g].aheadUpper = this.groups[g].ahead + this.groups[g].population;

          }
          if (!isNaN(this.groups[g].ahead)) {
            if (this.isFnPop) {
              if (this.groups[g].id.substr(0,3) != "age") {
                if (this.groups[g].ahead > this.model.totalAhead) {
                   this.model.totalAhead = this.groups[g].ahead;
                   this.model.totalPopulation = this.groups[g].population;
                   this.model.aheadUpper = this.groups[g].ahead + this.groups[g].population;
                }
              }
            } else {
              if (this.groups[g].id.substr(0,5) != "fnAge") {
               // this.model.totalAhead += this.groups[g].ahead;
               if (this.groups[g].ahead > this.model.totalAhead) {
                  this.model.totalAhead = this.groups[g].ahead;
                 this.model.totalPopulation = this.groups[g].population;
                  this.model.aheadUpper = this.groups[g].ahead + this.groups[g].population;

               }
              }
            }
          }

          if (this.isFnPop) {
            if (this.groups[g].id.substr(0,3) != "age") {
              this.model.totalDosesAllocated += this.groups[g].dosesAllocated;
            }
          } else {
            if (this.groups[g].id.substr(0,5) != "fnAge") {
              this.model.totalDosesAllocated += this.groups[g].dosesAllocated;
            }
          }
        }
      }
      for (let g in this.rows) {
        this.rows[g].bars[0].uptakePercentage = this.model.uptakePercentage;
        if (this.model.uptakePercentage == "70") {
          this.rows[g].bars[0].ahead = this.rows[g].bars[0].group.ahead70;
          this.rows[g].bars[0].population= this.rows[g].bars[0].group.population70;
          this.rows[g].bars[0].aheadUpper = this.rows[g].bars[0].ahead + this.rows[g].bars[0].population;

        }
        if (this.model.uptakePercentage == "80") {
          this.rows[g].bars[0].ahead = this.rows[g].bars[0].group.ahead80;
          this.rows[g].bars[0].population= this.rows[g].bars[0].group.population80;
          this.rows[g].bars[0].aheadUpper = this.rows[g].bars[0].ahead + this.rows[g].bars[0].population;

        }
        if (this.model.uptakePercentage == "90") {
          this.rows[g].bars[0].ahead = this.rows[g].bars[0].group.ahead90;
          this.rows[g].bars[0].population= this.rows[g].bars[0].group.population90;
          this.rows[g].bars[0].aheadUpper = this.rows[g].bars[0].ahead + this.rows[g].bars[0].population;

        }
        if (this.model.uptakePercentage == "100") {
          this.rows[g].bars[0].ahead = this.rows[g].bars[0].group.ahead100;
          this.rows[g].bars[0].population= this.rows[g].bars[0].group.population100;
          this.rows[g].bars[0].aheadUpper = this.rows[g].bars[0].ahead + this.rows[g].bars[0].population;
        }
      }

    if (this.fullVersion) {
      this.setPeopleIconsRangedGrouped();
    } else {
      this.setPeopleIcons();
    }

 });

    }
  },


  getBarLabel(groupId) {
    if (this.loaded) {
      if (this.groups[groupId]) {
        if (
        this.groups[groupId].id == "personalCareResidents"
        || this.groups[groupId].id == "firstNationsPriority"
        ||this.groups[groupId].id == "healthcareWorkers"
                ||this.groups[groupId].id == "congregateLiving"

        ) {
          let text = this.$t('combinedPeopleIcon');
        return text.formatUnicorn(this.groups[0][this.$store.state.lang].barLabel,
        this.groups[1][this.$store.state.lang].barLabel,
        this.groups[2][this.$store.state.lang].barLabel,
        this.groups[3][this.$store.state.lang].barLabel
        );
      } else {
        return this.groups[groupId][this.$store.state.lang].barLabel;
      }
    }
  }
  return null;
},
setChartBars() {
  this.$nextTick(() => {

    if (this.model.group) {
      for (let r in this.rows) {
        if (this.rows[r].bars[0].group.id == this.model.group.id) {
         this.rows[r].bars[0].isActive = 1;
         this.rows[r].bars[0].barHover = this.model.group[this.$store.state.lang].barHover;
       } else {
         this.rows[r].bars[0].isActive = 0;
         this.rows[r].bars[0].barHover = null;
       }
     }
   }

   this.scrollToResults();
   this.renderCount++;
 })
},
onPeopleHover(idx) {

},
onSubmit() {
  let minG = 9999;
  let minGQueue = 9999;
  let details = "";
  let barHover = "";
  let showDetails = 0;
  let hasChecked = false;

  this.isFnPop = false;

  this.model.totalPopulation = 0;
  this.model.uptakePopulation = 0;
  this.model.totalImmunized = 0;
  this.model.queuePosition = 0;
  this.model.queueStart = 0;
  this.model.queueEnd = 0;
  this.model.groupRemaining = 0;

  this.showQueuePosition = false;
  this.showChildren = false;
  this.showAgeRequired = false;
  this.showPregnant = false;
  this.showEstimate = false;
  this.showDosesOnly = false;
  this.showCustomGroupMessage = false;
  this.model.group = null;

  if (isNaN(parseInt(this.model.age,10))) {
    this.showAgeRequired = true;
    this.model.group = null;
    return;
  }
  var myAge = parseInt(this.model.age, 10);

  if (myAge > 120) myAge = 120;

  if (parseInt(this.model.age,10) < 18) {
       this.showChildren = true;
       for (let q in this.questions) {
         if(this.questions[q].isChecked) {
           hasChecked = true;
           // loop through its groups and see where the first group is in the queue.
           for(let qg in this.questions[q].group) {
             for (let g in this.groups) {
               if (this.questions[q].group[qg] == this.groups[g].groupId) {
                 if (this.groups[g].uptakePopulation > 0 || this.groups[g].showDosesOnly == 1) {
                  if (this.groups[g].queuePosition < minGQueue) {
                   if (this.questions[q].ageDetails) {
                     for(let a in this.questions[q].ageDetails) {
                       if (
                       myAge >= this.questions[q].ageDetails[a].fromAge && myAge <= this.questions[q].ageDetails[a].toAge
                       && myAge >= this.groups[g].fromAge && myAge <= this.groups[g].toAge
                       ) {
                         if (this.groups[g].id.substr(0,5) == "fnAge") {
                           this.isFnPop = true;
                         } else {
                           this.isFnPop = false;
                         }
                         minG = g;
                         minGQueue = this.groups[g].queuePosition;
                         this.model.group = this.groups[g];
                         this.model.groupRemaining += (this.groups[g].uptakePopulation - this.groups[g].totalImmunized);
                       }
                     }
                   }
                 }
               }
             }
            }
          }
        }
      }

      if (minG > 999) {
        for (let g in this.groups) {
          if (this.isFnPop) {
              if (this.groups[g].id.substr(0,5) == "fnAge") {
                if (myAge >= this.groups[g].fromAge && myAge <= this.groups[g].toAge) {
                  minG = g;
                  minGQueue = this.groups[g].queuePosition;
                  this.model.group = this.groups[g];
                  this.model.groupRemaining += (this.groups[g].uptakePopulation - this.groups[g].totalImmunized);
                }
              }
          } else {
            if (this.groups[g].id.substring(0,3) == "age") {
              if (myAge >= this.groups[g].fromAge && myAge <= this.groups[g].toAge) {
                minG = g;
                minGQueue = this.groups[g].queuePosition;
                this.model.group = this.groups[g];
                this.model.groupRemaining += (this.groups[g].uptakePopulation - this.groups[g].totalImmunized);
              }
            }
          }
        }
      }

    }
/*
          // loop through the age brackets now...
          for (let g in this.groups) {
            if (this.groups[g].id.substring(0,3) == "age") {
              if (myAge >= this.groups[g].fromAge && myAge <= this.groups[g].toAge) {
                minG = g;
                minGQueue = this.groups[g].queuePosition;
                this.model.group = this.groups[g];
                this.model.groupRemaining += (this.groups[g].uptakePopulation - this.groups[g].totalImmunized);
              }
            }
          }
          for (let q in this.ageOnlyAnswers) {
            if (this.ageOnlyAnswers[q].ageDetails) {
              for(let a in this.ageOnlyAnswers[q].ageDetails) {
                if (myAge >= this.ageOnlyAnswers[q].ageDetails[a].fromAge && myAge <= this.ageOnlyAnswers[q].ageDetails[a].toAge) {
                  this.model.group.showInfo = this.ageOnlyAnswers[q].ageDetails[a].showDetails;
                  if (this.model.group.showInfo) {
                    this.model.group[this.$store.state.lang].details = this.ageOnlyAnswers[q].ageDetails[a][this.$store.state.lang]["details"];
                    this.model.group[this.$store.state.lang].barHover = this.ageOnlyAnswers[q].ageDetails[a][this.$store.state.lang]["barHover"];
                  } else {
                    this.model.group[this.$store.state.lang].details = null;
                    this.model.group[this.$store.state.lang].barHover = this.ageOnlyAnswers[q].ageDetails[a][this.$store.state.lang]["barHover"];
                  }
                }
              }
            }
          }

        for (let q in this.questions) {
          if(this.questions[q].isChecked) {
            if (this.questions[q].questionId == "pregnant") {
              this.showPregnant = true;
              for (let g in this.groups) {
                if (this.groups[g].id == "pregnant") {
                  minG = g;
                  minGQueue = this.groups[g].queuePosition;
                  this.model.group = this.groups[g];
                  this.model.groupRemaining += (this.groups[g].uptakePopulation - this.groups[g].totalImmunized);
                }
              }
            }
          }
        }
      */

        if (this.showChildren == true || this.showPregnant == true) {
          this.showCustomGroupMessage = true;
          this.$nextTick(() => {
            this.setUptakePercentage();
            this.setChartBars();
          });
          return;
        }

        hasChecked = false;
        for (let q in this.questions) {
          if(this.questions[q].isChecked) {
            hasChecked = true;
            // loop through its groups and see where the first group is in the queue.
            for(let qg in this.questions[q].group) {
              for (let g in this.groups) {
                if (this.questions[q].group[qg] == this.groups[g].groupId) {
                  if (this.groups[g].uptakePopulation > 0 || this.groups[g].showDosesOnly == 1) {
                   if (this.groups[g].queuePosition < minGQueue) {
                    details = null;
                    showDetails = 0;
                    if (this.questions[q].ageDetails) {
                      for(let a in this.questions[q].ageDetails) {
                        if (
                        myAge >= this.questions[q].ageDetails[a].fromAge && myAge <= this.questions[q].ageDetails[a].toAge
                        && myAge >= this.groups[g].fromAge && myAge <= this.groups[g].toAge
                        ) {
                          if (this.groups[g].id.substr(0,5) == "fnAge") {
                            this.isFnPop = true;
                          } else {
                            this.isFnPop = false;
                              }                              // console.log("found group:"+this.groups[g].title);
                              // console.log(this.questions[q]);
                              // console.log(this.questions[q].group);
                              // console.log("myAge :"+myAge);
                              // console.log("fromAge:" + this.questions[q].ageDetails[a].fromAge);
                              // console.log("toAge:" + this.questions[q].ageDetails[a].toAge);

                              if (this.questions[q].ageDetails[a].showVaccinate == 1) {
                                if (this.questions[q].ageDetails[a].showDetails == 1) {
                                 details = this.questions[q].ageDetails[a][this.$store.state.lang].details;
                                 barHover = this.questions[q].ageDetails[a][this.$store.state.lang].barHover;
                               } else {
                                 details = null;
                                 barHover = this.questions[q].ageDetails[a][this.$store.state.lang].barHover;
                               }
                               showDetails = this.questions[q].ageDetails[a].showDetails;
                             }
                             minGQueue = this.groups[g].queuePosition;
                             minG = g;
                             this.model.groupRemaining += (this.groups[g].uptakePopulation - this.groups[g].totalImmunized);
                           }
                         }
                       } else {
                        if (this.groups[g].id.substr(0,5) == "fnAge") {
                          this.isFnPop = true;
                        } else {
                          this.isFnPop = false;
                        }
                        minGQueue = this.groups[g].queuePosition;
                        minG = g;
                        this.model.groupRemaining += (this.groups[g].uptakePopulation - this.groups[g].totalImmunized);
                      }
                    }
                  }
                }
              }
            }
          }
        }
        // calculate totals first.
        for (let g in this.groups) {
          this.model.uptakePopulation += this.groups[g].uptakePopulation;
          this.model.totalImmunized += this.groups[g].totalImmunized;
        }

        if (hasChecked == false) {
          // loop through the age brackets now...

          for (let q in this.ageOnlyAnswers) {
            if (this.ageOnlyAnswers[q].ageDetails) {
              for(let a in this.ageOnlyAnswers[q].ageDetails) {
                if (myAge >= this.ageOnlyAnswers[q].ageDetails[a].fromAge && myAge <= this.ageOnlyAnswers[q].ageDetails[a].toAge) {
                        // if (this.ageOnlyAnswers[q].ageDetails[a].showVaccinate == 1) {
                          if (this.ageOnlyAnswers[q].ageDetails[a].showDetails == 1) {
                           details = this.ageOnlyAnswers[q].ageDetails[a][this.$store.state.lang]["details"];
                           barHover = this.ageOnlyAnswers[q].ageDetails[a][this.$store.state.lang]["barHover"];
                         } else {
                          details = null;
                          barHover = this.ageOnlyAnswers[q].ageDetails[a][this.$store.state.lang]["barHover"];
                        }
                        showDetails = this.ageOnlyAnswers[q].ageDetails[a].showDetails;
                        // }
                      }
                    }
                  }
                }
                for (let g in this.groups) {
                  if (this.groups[g]) {
                    if (typeof this.groups[g].id != "undefined") {
                      if (this.groups[g].id.substring(0,3) == "age") {
                        if (myAge >= this.groups[g].fromAge && myAge <= this.groups[g].toAge) {
                          minG = g;
                          minGQueue = this.groups[g].queuePosition;
                          this.model.group = this.groups[g];
                          this.model.groupRemaining += (this.groups[g].uptakePopulation - this.groups[g].totalImmunized);
                        }
                      }
                    }
                  }
                }
              }


        // now find where our group queues in.
        this.model.queueStart = 0;
        for (let g in this.groups) {
          if (g == minG) {
           this.model.queueEnd = this.model.queueStart + this.model.groupRemaining;
           this.model.group = this.groups[g];
           if (showDetails) {
             this.model.group.showInfo = 1;
             this.model.group[this.$store.state.lang].details = details;
             this.model.group[this.$store.state.lang].barHover = barHover;
           } else {
            this.model.group[this.$store.state.lang].details = null;
            this.model.group[this.$store.state.lang].barHover = barHover;
          }
          break;
        } else {
          if (this.isFnPop) {
            if (this.groups[g].id.substr(0,3) != "age") {
              this.model.queueStart += (this.groups[g].uptakePopulation - this.groups[g].totalImmunized);
            }
          } else {
            if (this.groups[g].id.substr(0,5) != "fnAge") {
              this.model.queueStart += (this.groups[g].uptakePopulation - this.groups[g].totalImmunized);
            }
          }
        }
      }

      this.activeBarHover = barHover;
      this.showCustomGroupMessage = this.model.group.showCustomGroupMessage;

      if (this.isFnPop) {
        this.rows = this.fnRows;
      } else {
        this.rows = this.popRows;
      }
      this.showEstimate = true;
      this.showQueuePosition = false;
      if (!this.showCustomGroupMessage) {
        if (this.model.group.showDosesOnly == 1) {
          this.showDosesOnly = true;
        } else {
          this.showQueuePosition = true;
        }
      } else {
        this.showQueuePosition = true;
      }

      this.$nextTick(() => {
        this.setUptakePercentage();
        this.setChartBars();
      });
      // this.setPeopleIcons();

    }
  },
  computed: {
    ...mapGetters([
    ]),
    showAdditionalInfo() {
      if (this.model.group) {
        return this.model.group.showInfo;
      }
      return false;

    },
    showCustomGroupSlider() {
      if (this.model.group) {
        if (this.model.group.id == "congregateLiving") {
          return false;
        }
      }
      return false;
    },

    getResultsTextAbove() {
      if (this.model.totalBefore == 0 && this.model.totalAfter == 0) {
        return this.$t("resultsTextAboveZero");
      } else {
        return this.$t("resultsTextAbove");
      }
    },
    getResultsTextBelow() {
      if (this.loaded && this.model) {
        if(this.model.group) {
          if (this.model.group.ahead == 1) {
            let text = this.$t("totalBeforeIsOne");
            return this.getParsedString(text);
          // return text.formatUnicorn(this.model.group[this.$store.state.lang].barLabel, numeral(this.model.uptakePopulation).format(),numeral(this.model.totalImmunized).format(), numeral(this.model.queueStart).format(), numeral(this.model.queueEnd).format());
        } else {
          let text = this.$t("totalBeforeIsMany");
          return this.getParsedString(text);

          // return text.formatUnicorn(this.model.group[this.$store.state.lang].barLabel, numeral(this.model.uptakePopulation).format(),numeral(this.model.totalImmunized).format(), numeral(this.model.queueStart).format(), numeral(this.model.queueEnd).format());
        }
      }
    }
    return null;
  },
  getResultsPeople() {
    return null;
  },

  getHeaderIntro() {
    return null;
  },

  getHeaderSubtitle() {
    return null;
  },


  getHeaderTotal() {
    var html = "";
    return html;
  },

  getLastUpdated() {
    return null;
  },

 getCustomGroupTextAbove() {
  if (this.loaded && this.model.group) {
    let text = this.model.group[this.$store.state.lang].customTitle;
    return this.getParsedString(text);
  }
  return null;
},
getCustomGroupTextNumber() {
  if (this.loaded && this.model.group) {
    let text = this.model.group[this.$store.state.lang].customNumber;
    return this.getParsedString(text);
  }
  return null;
},
getCustomGroupTextBelow() {
  if (this.loaded && this.model.group) {
    let text = this.model.group[this.$store.state.lang].customBelow;
    return this.getParsedString(text);
  }
  return null;
},
getCustomGroupTextDetails() {
  if (this.loaded && this.model.group) {
    let text = this.model.group[this.$store.state.lang].customDetails;
    return this.getParsedString(text);
  }
  return null;
},
getDosesTextAbove() {
  if (this.loaded && this.model.group) {
    if (this.model.group.dosesAllocated == 0) {
      return this.$t("dosesTextAboveZero");
    } else {
      return this.$t("dosesTextAbove");
    }
  }
},
getDosesText() {
  if (this.loaded && this.model.group) {
    let text = ""+this.$t('dosesText');
    return text.formatUnicorn(numeral(this.model.group.dosesAllocated).format());
  }
  return  null;
},
getDosesTextBelow() {
  if (this.loaded && this.model.group) {
    let text = ""+this.$t('dosesTextBelow');
    return text.formatUnicorn(numeral(this.model.group.dosesAllocated).format());

  }
},

getQueueText() {
  if (this.loaded && this.model) {
    if(this.model.group) {
        if (this.showRange) {
          let upperEnd = this.model.group.ahead + this.model.group.population;
          return numeral(this.model.group.ahead).format("0,0") + " - " + numeral(upperEnd).format("0,0");
        } else {
          return numeral(this.model.group.ahead).format("0,0");
        }
    }
  }
  return  null;
},

getQueueTextRange() {
  if (this.loaded) {
    if (this.model.queueStart == 0 && this.model.queueEnd == 0) {
      return "0";
    }
    return numeral(this.model.queueStart).format("0,0") + " - " + numeral(this.model.queueEnd).format("0,0");
  }
  return  null;
},

getResultsInfo() {
  if (this.loaded) {
    if (this.showPregnant) {
      if (this.model.group) {
        return this.getParsedString(this.model.group[this.$store.state.lang].details);
      }
    } else if (this.showChildren) {
      if (this.model.group) {
        return this.getParsedString(this.model.group[this.$store.state.lang].details);
      }
    } else {
      if (this.model.group) {
        return this.getParsedString(this.model.group[this.$store.state.lang].details);
      }
    }
  }
  return null;
},

getResultsChildren() {
  if (this.loaded) {
    for (let g in this.groups) {
      if(this.groups[g].id == "age0to17") {
        return this.groups[g][this.$store.state.lang].details;
      }
    }
  }
  return null;
},

getSliderLabel() {
  let text = this.$t('sliderLabel');
  return text.formatUnicorn(this.model.uptakePercentage);
},
getSliderLabelSide() {
  let text = this.$t('sliderLabelSideBySide');
  return text.formatUnicorn(this.model.uptakePercentage);
},



},
created () {
  if (this.$store.state.lang == "fr") {
    numeral.locale('fr');
  } else {
    numeral.locale('en');
  }

  window.$bus.$on('peoplechart:hover', this.onPeopleHover);
},
watch: {
  'model.question':function() {
    this.showPregnant = false;
    this.showEstimate = false;
  },
  'model.uptakePercentage':function() {
    this.setUptakePercentage();
  },
},
mounted () {

  if (this.$store.state.lang == "fr") {
    this.$moment().locale(this.$store.state.lang + "-88591");
  } else {
    this.$moment().locale(this.$store.state.lang + "-ca");
  }
}
}
</script>

<style lang="scss" scoped>
@import '../scss/_index';
$label-color: red;
// @import "../../node_modules/vue-custom-range-slider/dist/vue-custom-range-slider.css";
@import "../../node_modules/vue-horizontal-scroll/dist/vue-horizontal-scroll.css";



.slider {
  z-index:0;
  ::v-deep .slider__label {
    font-family:$number-font;
    position:absolute;
    top: 3px;
    border: 4px solid $blue;
    border-radius: 50%;
    background: transparent;
    color:$blue;
    z-index:1;
  }
  ::v-deep .slider__track {
    width:100%;
    position:absolute;
    z-index:0;
    height:5px;
    color:$blue;
  }
  ::v-deep .slider__label:after {
    top:20px;
    bottom:0px;
    color:$blue;
    background:transparent;
  }
  ::v-deep  .slider__input {
    background:transparent;
  }
  ::v-deep  .slider__input::range-thumb {
    height:30px;
    width:30px;
    background:transparent;
    border-radius:50%;
    cursor:pointer;
    border:none;
  }
}

</style>

